import { loadView } from '@/router'

export default [
  {
    path: 'accounts',
    name: 'sales-accounts',
    component: loadView('Application/Sales/Accounts'),
    redirect: {
      name: 'sales-accounts-list'
    },
    children: [
      {
        path: 'list',
        name: 'sales-accounts-list',
        component: loadView('Application/Sales/Accounts/List')
      },
      {
        path: ':accountId',
        name: 'sales-accounts-account',
        component: loadView('Application/Sales/Accounts/Account'),
        redirect: {
          name: 'sales-accounts-account-dashboard'
        },
        children: [
          {
            path: 'contacts',
            name: 'sales-accounts-account-contacts',
            component: loadView('Application/Sales/Accounts/Account/Contacts')
          },
          {
            path: 'dashboard',
            name: 'sales-accounts-account-dashboard',
            component: loadView('Application/Sales/Accounts/Account/Dashboard')
          },
          {
            path: 'details',
            name: 'sales-accounts-account-details',
            component: loadView('Application/Sales/Accounts/Account/Details')
          },
          {
            path: 'configure',
            name: 'sales-accounts-account-configure',
            component: loadView('Application/Sales/Accounts/Account/Configure')
          },
          {
            path: 'trackingservices',
            name: 'sales-accounts-account-trackingservices',
            component: loadView('Application/Sales/Accounts/Account/TrackingServices')
          },
          {
            path: 'carriers',
            name: 'sales-accounts-account-carriers',
            component: loadView('Application/Sales/Accounts/Account/Carriers')
          },
          {
            path: 'enquiries',
            name: 'sales-accounts-account-enquiries',
            component: loadView('Application/Sales/Accounts/Account/Enquiries')
          },
          {
            path: 'notes',
            name: 'sales-accounts-account-notes',
            component: loadView('Application/Sales/Accounts/Account/Notes')
          },
          {
            path: 'pickups',
            name: 'sales-accounts-account-pickups',
            component: loadView('Application/Sales/Accounts/Account/Pickups')
          },
          {
            path: 'todo',
            name: 'sales-accounts-account-todo',
            component: loadView('Application/Sales/Accounts/Account/ToDo')
          },
          {
            path: 'attachments',
            name: 'sales-accounts-account-attachments',
            component: loadView('Application/Sales/Accounts/Account/Attachments')
          },
          {
            path: 'histories',
            name: 'sales-accounts-account-histories',
            component: loadView('Application/Sales/Accounts/Account/Histories')
          },
          {
            path: 'invoices',
            name: 'sales-accounts-account-invoices',
            component: loadView('Application/Sales/Accounts/Account/Invoices')
          }
        ]
      }
    ]
  }
]
